// ZOD
import * as z from 'zod';
import { ExpertiseZod, ExpertiseType, ExpertiseSlugType, ExpertiseSlugZod } from '@/views/Expertise/ExpertiseType';

// Strapi
import { blocks, seo } from '@/services/strapiPopulate';
import { fetchStrapiContentWithBlocks } from '@/services/blocks/fetchStrapiContentWithBlocks';

// Utils
import { formatZodError } from '@/utils/error';

// Client
import client from '../client';

export const getExpertise = async (slug: string): Promise<ExpertiseType> =>
  fetchStrapiContentWithBlocks(`/api/expertises/${slug}`, ExpertiseZod, { blocks, seo }, 'Expertise Page');

export const getExpertises = async (): Promise<Array<ExpertiseSlugType>> => {
  const pageSize = 10;
  const response = await client.get('/api/expertises', {
    params: {
      fields: ['slug'],
      populate: {
        seo,
      },
      pagination: {
        page: 1,
        pageSize,
      },
    },
  });

  const totalPages = response.data?.meta?.pagination.pageCount || 1;
  const allData = [...(response.data?.data ?? [])];

  try {
    if (totalPages > 1) {
      const pagePromises = Array.from({ length: totalPages - 1 }, (_, i) =>
        client.get('/api/expertises', {
          params: {
            fields: ['slug'],
            populate: {
              seo,
            },
            pagination: { page: i + 2, pageSize },
          },
        }),
      );
      const results = await Promise.all(pagePromises);
      results.forEach((r) => allData.push(...(r.data?.data || [])));
    }

    return z.array(ExpertiseSlugZod).parseAsync(allData);
  } catch (error) {
    if (error instanceof z.ZodError) {
      throw new Error(`API response do not match Expertises structure:\n${formatZodError(error, allData)}`);
    }
    throw error;
  }
};
